import {ActionsPage as ActionsPageContainer} from '@features/pom'
import {PageContainer, PageTitle} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'

export const ActionsPage: React.FC = () => {
  const {t} = useTranslation()
  return (
    <PageContainer>
      <PageTitle>{t('actionsPage.title')}</PageTitle>
      <ActionsPageContainer inverted />
    </PageContainer>
  )
}
